import Reveal from "./Reveal";

export const SectionHeading = ({ kicker, title, description, dark = false }) => (
    <div className="mb-14 sm:mb-20">
        <Reveal>
            <p
                className={`font-mono text-xs uppercase tracking-[0.3em] ${
                    dark ? "text-gold" : "text-crimson"
                }`}
            >
                {kicker}
            </p>
        </Reveal>
        <Reveal delay={0.1}>
            <h2
                className={`mt-4 font-display text-3xl sm:text-5xl font-light tracking-tight leading-[1.05] ${
                    dark ? "text-paper" : "text-ink"
                }`}
            >
                {title}
            </h2>
        </Reveal>
        {description && (
            <Reveal delay={0.2}>
                <p
                    className={`mt-5 max-w-xl text-base sm:text-lg leading-relaxed ${
                        dark ? "text-paper/70" : "text-subtle"
                    }`}
                >
                    {description}
                </p>
            </Reveal>
        )}
    </div>
);

export default SectionHeading;
